import { styled, css } from 'styled-components'

export const Label = styled.div`
  color: ${({ theme }) => theme.colors.black || '#2B0514'};
  margin-bottom: 0.25rem;
`

// Mimic the input field created by stripe address element
export const Input = styled.input`
  padding: 0.75rem;
  border-radius: 5px;
  transition:
    background 0.15s ease,
    border 0.15s ease,
    box-shadow 0.15s ease,
    color 0.15s ease;
  border: 1.5px solid #e6e6e6;
  box-shadow:
    0 1px 1px rgb(0 0 0 / 3%),
    0 3px 6px rgb(0 0 0 / 2%);
  font-size: inherit;
  color: ${({ theme }) => theme.colors.black || '#2B0514'};

  &#stripe-input {
    background: #ffffff !important;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.grayDark || '#958289'};
  }

  &:focus {
    outline: none;
    box-shadow: none;
    border-color: ${({ theme }) => theme.colors.black || '#2B0514'};
  }

  ${({ $invalid, theme }) =>
    $invalid &&
    css`
      border-color: ${theme.colors.errorRed};
      box-shadow:
        0 1px 1px rgba(0, 0, 0, 0.03),
        0 3px 6px rgba(0, 0, 0, 0.02),
        0 0 0 1px ${theme.colors.errorRed};
    `}
`
